import { LabelTextGroupListCombinedProps } from './types';

const usePresenter = (props: LabelTextGroupListCombinedProps): LabelTextGroupListCombinedProps => {
  return props;
};

export default usePresenter;
